import { Injectable, ErrorHandler } from "@angular/core";
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as StackTrace from 'stacktrace-js';
import { AppModule } from "app/app.module";
import { Router, NavigationEnd } from "@angular/router";

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  handleError(error) {
    const message = error.message ? error.message : error.toString();
    const route = AppModule.injector.get(Router);
    const location = AppModule.injector.get(LocationStrategy);
    const url = location instanceof PathLocationStrategy ? location.path() : '';

    StackTrace.fromError(error).then(stackframes => {
      const stackString = stackframes.splice(0, 20)
        .map(function (sf) {
          return sf.toString();
        }).join('\n');

      super.handleError(error);
    });
  }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/handlers/global.error.handler.ts